<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Orden de Compra</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-5">
              <OrdenCompraModelAddComponent />
            </div>
            <div class="col-sm-12">
              <div class="row justify-content-sm-end">
                <div class="col-2">
                  <label>Fecha</label>
                  <input
                    type="date"
                    v-model="filter.fecha"
                    class="form-control form-control-sm"
                    @change="filterData()"
                  />
                </div>
                <ProveedoresSelectComponent
                  class="col-sm-3"
                  style="display: block"
                  :current="filter"
                  @change="filterData()"
                  @onChange="filterData()"
                />
                <UsuariosSelectComponent
                  class="col-sm-3"
                  style="display: block"
                  :current="filter"
                  @change="filterData()"
                  @onChange="filterData()"
                />
              </div>
              <div class="form-inline justify-content-sm-end">
                <button
                  type="button"
                  @click="modalTiendaSelect"
                  class="btn btn-dark btn-sm"
                >
                  Cambiar Tienda
                  <i class="fas fa-history"></i>
                </button>
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar Numero"
                  v-model="filter.searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filter.estado_str"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="C">De Baja</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <OrdenCompraTableComponent :dataTabla="dataTabla" />
      </div>
      <PaginationComponent
        :currentPage="currentPage"
        :data="dataTabla"
        @pagechanged="filterData"
      />
    </div>
    <div
      class="modal fade"
      id="modalTiendaSelect"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Elije una tienda</h5>
          </div>
          <div class="modal-body">
            <select
              class="form-control col-12"
              v-model="filter.tienda"
              @change="filterData()"
            >
              <option v-for="(item, key) in tiendas" :value="item.codigo" :key="key">
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="clearFilterData()"
            >
              Cerrar
              <small>(Se mostraran todas las tiendas)</small>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import OrdenCompraModelAddComponent from "@/components/compras/ordencompra/OrdenCompraModelAddComponent";
import OrdenCompraTableComponent from "@/components/compras/ordencompra/OrdenCompraTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    OrdenCompraTableComponent,
    UsuarioEnTablaComponent,
    OrdenCompraModelAddComponent,
    PaginationComponent,
    UsuariosSelectComponent,
    ProveedoresSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        proveedor: "",
        fecha: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      dataTabla1: "cotizaciones/cotizaciones",
      dataTabla: "ordencompra/orden_compras",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    this.$store.dispatch("cotizaciones/fetch");
    this.$store.dispatch("ordencompra/fetch");
    $("#modalTiendaSelect").modal("show");
  },
  methods: {
    modalTiendaSelect() {
      $("#modalTiendaSelect").modal("show");
    },
    filterData(page) {
      let proveedor;
      let usuario;
      let fecha;
      if (this.filter.fecha) {
        fecha = moment(this.filter.fecha).format("DD/MM/YYYY");
      }
      if (this.filter.proveedor) {
        proveedor = this.filter.proveedor.codigo;
      }
      if (this.filter.usuario) {
        usuario = this.filter.usuario.id;
      }
      if (page) {
        this.currentPage = page;
      }
      this.$store.dispatch("ordencompra/orden_compras", {
        "filter[search]": this.filter.searchtext,
        page: page,
        fecha: fecha,
        tienda: this.filter.tienda,
        estado: this.filter.estado_str,
        proveedor: proveedor,
        usuario: usuario,
        numero: this.filter.numero,
      });
      $("#modalTiendaSelect").modal("hide");
    },
    clearFilterData() {
      this.filter.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.tienda = "";
      this.filter.proveedor = "";
      this.filter.fecha = "";
      this.filter.usuario = "";
      this.$store.dispatch("ordencompra/orden_compras", {
        page: this.$data.currentPage,
        "filter[search]": this.filter.tienda,
      });
    },
  },
};
</script>
